// extracted by mini-css-extract-plugin
module.exports = {"root":"Community_root__1WOY-","lastUpdated":"Community_lastUpdated__253Bi"};